const callApiClientGetAsync = async (path, urlSearchParams, accessToken) => {
    const params = urlSearchParams ? new URLSearchParams(urlSearchParams) : null;
    const paramsString = params ? `?${params}`: '';
    //All these calls should be authenticated. 
    const fetchUrl = `${process.env.REACT_APP_ANPR_API_BASE_URL}/${path}${paramsString}`;
    const response = await fetch(
        fetchUrl,
        { 
            headers: {
                Authorization: `Bearer ${accessToken}`
            }
        });

    const result = await response.json()
    return result;
}

const callApiClientPostAsync = async (path, body, accessToken, urlSearchParams) => {
    //All these calls should be authenticated. 
    const params = urlSearchParams ? new URLSearchParams(urlSearchParams) : null;
    const paramsString = params ? `?${params}`: '';
    const fetchUrl = `${process.env.REACT_APP_ANPR_API_BASE_URL}/${path}${paramsString}`;
    const response = await fetch(
        fetchUrl,
        { 
            method: "POST",
            headers: {
                Authorization: `Bearer ${accessToken}`,
                ContentType: "application/json"
            },
            body:  JSON.stringify(body)
        });

    const result = await response
    return result;
}



const getVehiclesForGroupAsync = async (queryParameters, accessToken) =>
    callApiClientGetAsync("getvehicleentriesforgroupbyalertstatus", queryParameters, accessToken);

const getPubSubClientAccessUrlAsync = async (queryParameters, accessToken) =>
    callApiClientGetAsync("getclienturlreceivemessage", queryParameters, accessToken);

const getVehicleRegistrationStatusManualCheckAsync = async (queryParameters, accessToken) =>
    callApiClientGetAsync("getvehicleregistrationstatusmanualcheck", queryParameters, accessToken);

const getVehicleHistoryAsync = async (queryParameters, accessToken) =>
    callApiClientGetAsync("getvehiclerecordsforplate", queryParameters, accessToken);

const postAutoscanSettingForServo = async (body, accessToken) =>
    callApiClientPostAsync("updateautoscansettingforservo", body, accessToken);

const getAutoScansettingForServoAsync = async (queryParameters, accessToken) =>
    callApiClientGetAsync("getautoscansettingforservo", queryParameters, accessToken);

const getVehicleDriveOffsForPlateAsync = async (queryParameters, accessToken) =>
    callApiClientGetAsync("getvehicledriveoffsforplateasync", queryParameters, accessToken);

const getSelectedVehicleForPlateAsync = async (queryParameters, accessToken) =>
    callApiClientGetAsync("getselectedvehicleforplateasync", queryParameters, accessToken);

const setVehicleDriveOffAsync = async (queryParameters, accessToken) =>
    callApiClientGetAsync("setvehicledriveoffasync", queryParameters, accessToken);

const postSettleVehicleDriveOffsAsync = async (body, accessToken, params) =>
    callApiClientPostAsync("settlevehicledriveoffsforplateasync", body, accessToken, params);

const getVehicleDriveOffsAsync = async (queryParameters, accessToken) =>
    callApiClientGetAsync("getvehicledriveoffs", queryParameters, accessToken);

const postManualDetectionEntry = async (queryParameters, imageFiles, accessToken) => {
    const params = new URLSearchParams(queryParameters);
    const fetchUrl = `${process.env.REACT_APP_ANPR_API_BASE_URL}/camera_detections_manual_entry?${params}`;

    const formData = new FormData();
    if (imageFiles.image1) formData.append('image1', imageFiles.image1);
    if (imageFiles.image2) formData.append('image2', imageFiles.image2);
    if (imageFiles.image3) formData.append('image3', imageFiles.image3);

    const response = await fetch(fetchUrl, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${accessToken}`
        },
        body: formData
    });

    const result = await response.json();
    return result;
};

export default {
    getVehiclesForGroupAsync,
    getPubSubClientAccessUrlAsync,
    getVehicleRegistrationStatusManualCheckAsync,
    getVehicleDriveOffsForPlateAsync,
    getVehicleDriveOffsAsync,
    postSettleVehicleDriveOffsAsync,
    getVehicleHistoryAsync: getVehicleHistoryAsync,
    getSelectedVehicleForPlateAsync,
    postAutoscanSettingForServo,
    getAutoScansettingForServoAsync,
    setVehicleDriveOffAsync,
    postManualDetectionEntry
};
